import React ,{useState} from 'react'
import { useHistory } from "react-router-dom";
import {loadStripe} from '@stripe/stripe-js';
import {Elements, useStripe, useElements,PaymentElement} from '@stripe/react-stripe-js';



const CheckoutOne = (props) => {
    const stripePromise = loadStripe('pk_test_51JmYlkI3xHXhHyw4hFbxcbGNIaUdaS1VqHWznhmjRsFuZyKWK54YcBncd92OZlGqZuUK8UDj43qpCfLpLNNpyy5f007vXuYoKD');
    const CheckoutForm = () => {
      const [disableForm, setDisableForm] = useState(false);
      const stripe = useStripe();
      const elements = useElements();
      const history = useHistory();
    
      const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        setDisableForm(true)
        if (!stripe || !elements) {
          // Stripe.js has not yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          return;
        }
    
        const result = await stripe.confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements,
          confirmParams: {
            return_url: "http://localhost:3000/order-complete",
          },
          redirect: 'if_required' 

        });
    
    
        if (result.error) {
          props.paymentStatus(false,result.error.message)
          // Show error to your customer (for example, payment details incomplete)
          console.log(result.error.message);
          setDisableForm(false)
        } else {
          console.log(result);
          props.paymentStatus(true,result)
          setDisableForm(false)
            //history.push("/order-complete",result)
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }
      };
    
      return (
        <form className={disableForm?'readonlyform':''} onSubmit={handleSubmit}>
         {disableForm && <div className='text-center mb-3 h3 font-weight-lighter'>
          <div className="spinner-border text-dark"> </div> Fetching card details...
          </div>}
         
          <PaymentElement />
          <button className='theme-btn-one btn_md btn-block btn-black-overlay mt-3' disabled={!stripe}>Submit</button>
        </form>
      )
    };
      return (
        <>
        {/* <Banner title="Checkout" /> */}
        <div className='row pb-5'>
        
            <div className='col-lg-8 offset-lg-2'>
            <Elements stripe={stripePromise} options={props.stripeOptions}>
              <CheckoutForm />
            </Elements>
            </div>
        </div>
        
        </>
      );
    
}

export default CheckoutOne

